import { render, staticRenderFns } from "./signUpTips.vue?vue&type=template&id=65f1e9f1&scoped=true"
import script from "./signUpTips.vue?vue&type=script&lang=js"
export * from "./signUpTips.vue?vue&type=script&lang=js"
import style0 from "./signUpTips.vue?vue&type=style&index=0&id=65f1e9f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1e9f1",
  null
  
)

export default component.exports